import { Backdrop, Box, LinearProgress, Typography } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { MyRenderCell } from "../../components/MyRenderCell";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getTransactions } from "../../redux/slices/transactions";
import { RootState } from '../../redux/store';

export const Transactions = () => {

    const { isLoading, transactions = [] } = useAppSelector((state: RootState) => state.transactions);
    const [pageSize, setPageSize] = useState<number>(20);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getTransactions());
    }, [dispatch])

    const Columns: GridColDef[] = [
        {
            field: 'id',
            headerName: 'Id',
            width: 100,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'material',
            headerName: 'Material',
            width: 400,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'isbn',
            headerName: 'ISBN',
            width: 200,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 100,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'reason',
            headerName: 'Reason',
            width: 100,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            width: 100,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'workOrderId',
            headerName: 'Work Order',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'comment',
            headerName: 'Comment',
            width: 400,
            renderCell: (params) => (<MyRenderCell params={params} />)
        }
    ]

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <Box sx={{ width: '40%' }}>
                    <LinearProgress />
                </Box>
            </Backdrop>
            <>
                <Typography variant="h4" component="h1">Inventory Tracking</Typography>
                <br />
            </>
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid
                    rows={transactions}
                    columns={Columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[20, 50, 100]}
                    columnVisibilityModel={{ id: false, }}
                //checkboxSelection
                />
            </div>
        </div >
    )
}
